module.exports = __webpack_public_path__ + "static/media/filter-orange.423f0094.png";